import { IInternalSend } from 'src/types/internal';
import { InternalFormData } from 'src/screens/General/screens/Internals/components/InternalForm';
import { changeToZeroMomentDate } from '../timeHelpers';

const groupInternal = (dataForm: Partial<InternalFormData>): Partial<IInternalSend> => {
    const { internalDate, amount, providerDropDown, ...data } = dataForm;
    const dataSend: Partial<IInternalSend> = { ...data };

    if (providerDropDown) {
        dataSend.provider = providerDropDown.value;
    }

    if (amount) {
        dataSend.amount = parseFloat(`${amount}`);
    }
    if (internalDate) {
        dataSend.internalDate = changeToZeroMomentDate(internalDate);
    }

    return dataSend;
};
export { groupInternal };
